import { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { renderInline } from "./renderInline";

export const slugify = (s) => String(s || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").split("-").slice(0, 2).join("-");

// One collapsible section of a guide card: collapsed = title + optional teaser + "Show".
export const GuideSection = ({ section, accent = "#1D4ED8", testKey, children, listen = null }) => {
  const [open, setOpen] = useState(!section.collapsed);
  useEffect(() => { setOpen(!section.collapsed); }, [section.collapsed]);
  const key = testKey ?? section.key;
  const id = slugify(section.title || String(key));
  useEffect(() => { if (typeof window !== "undefined" && window.location.hash === `#${id}`) setOpen(true); }, [id]);
  return (
    <div id={id} className="scroll-mt-28" data-testid={`guide-section-${key}`} data-collapsed={!open}>
      {!open ? (
        <div className="rounded-xl border bg-white px-5 py-4" style={{ borderColor: `${accent}33` }}>
          <h3 className="text-base md:text-xl font-extrabold uppercase tracking-[0.15em]" style={{ color: accent }}>{section.title}</h3>
          {section.teaser && <p className="mt-2 text-[15px] leading-relaxed text-[#3a3a3a] [&_strong]:text-[#1A1A1A]" data-testid={`guide-teaser-${key}`}>{renderInline(section.teaser, accent)}</p>}
          <button type="button" onClick={() => setOpen(true)} className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-white border-2 px-4 py-2 text-sm font-extrabold" style={{ color: accent, borderColor: `${accent}55` }} data-testid={`guide-show-${key}`}>
            {section.show_label || "Show"} <ChevronDown className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <div>
          {listen && <div className="float-right ml-3 mb-1">{listen}</div>}
          {children}
          {section.collapsed && (
            <button type="button" onClick={() => setOpen(false)} className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-[#5C5C5C] hover:opacity-80" data-testid={`guide-hide-${key}`}>
              Hide <ChevronDown className="h-3.5 w-3.5 rotate-180" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default GuideSection;
